import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navigationStyle: 1,
    screenWidth:document.documentElement.clientWidth, //螢幕寬度
    screenHeight:document.documentElement.clientHeight, //螢幕高度
  },
  mutations: {
    setNavigationStyle(state, int) {
      state.navigationStyle = int;
    }
  },
  actions: {
  },
  modules: {
  }
})
